
import * as messages from '@radnuc/messages';
import * as thrift from 'thrift';
import {IBACReading, METReading} from '../BD21Device'
import { BD21DataStream, DataPacket } from '../BD21DataStream';
import colormap from "colormap";
import npyjs from "npyjs";
//import zlib from "zlib";
import jszip from "jszip";

import rawNPZFile from './dp4dr8.npz'

import rawDoseMapFile from './dose.npy'; //'./dp4dr8.npz';
import rawDoseStdMapFile from './dose_std.npy'; //'./dp4dr8.npz';
//import readNumpyFile from 'read-npy-file'

//const npyz = require("./npyz");
interface ThriftWritable {
    write: (protocol: thrift.TProtocol) => void;
}

interface EnableFlags {
    //investigation?: boolean,
    bio?: boolean,
    met?: boolean,
    cbsigma?: boolean,
    radEncounter? : boolean,
    //dosemap?: boolean,
}

export class FakeDataGenerator {
    callback: (data: DataPacket[]) => void;
    position: [number, number] = [0, 0]

    constructor(callback: (data: DataPacket[]) => void, enable?: EnableFlags) {
        this.callback = callback;

        if (!enable || enable.bio)
            this.bioMessageLoop();
        if (!enable || enable.cbsigma)
            this.encounterMessageLoop();
        if (!enable || enable.radEncounter)
            this.radEncounterMessageLoop();
        //if (!enable || enable.dosemap)
        //    this.doseMessageLoop();
    }

    bioMessageLoop() {

        let msg_number = 0;
        const center_lat = 42.754193;
        const center_lon = -71.111716;

        setInterval(() => {
            msg_number++;
            const position = [
                center_lat + (0.005) * Math.sin(msg_number / 50),
                center_lon + (0.005) * Math.cos(msg_number / 50)
            ];

            let dev1_alarm = false;
            if(msg_number % 50 > 35){
                //dev1_alarm = true;
            }
            const sm_bio_count = msg_number % 30 + 300;
            const lg_bio_count = msg_number % 40 + 80;
            const conf = (msg_number % 20 + 70)/100.0;
            let message = new IBACReading(
                'device1',
                'sensor1',
                Date.now(),
                position[0],
                position[1],
                sm_bio_count,
                lg_bio_count,
                sm_bio_count,
                lg_bio_count,
                0.5
            );

            //let event = new MessageEvent('plottableSensorReadings', { data: message});
            //this.callback(event);

            const position2 = [
                center_lat + (0.005) * Math.sin((msg_number+100) / 50),
                center_lon + (0.005) * Math.cos((msg_number+100) / 50)
            ];
            let dev2_alarm = false;
            if((msg_number+25) % 30 > 20){
                //dev2_alarm = true;
            }
            let message2 = new IBACReading(
                'device2',
                'sensor2',
                Date.now(),
                position2[0],
                position2[1],
                sm_bio_count,
                lg_bio_count,
                sm_bio_count,
                lg_bio_count,
                0.5
            );
            let event2 = new MessageEvent('plottableSensorReadings', { data: message2});

            //this.callback(event2);
        }, 1000);
    }


    generateRandomId() {
        return new messages.Core.UUID({
            leastSignificantBits: new thrift.Int64(window.crypto.getRandomValues(new Buffer(8))) as unknown as number,
            mostSignificantBits: new thrift.Int64(window.crypto.getRandomValues(new Buffer(8))) as unknown as number
        });
    }


    encounterMessageLoop() {

        let msg_number = -1;
        let msg_id = this.generateRandomId();
        let msg_start_time = 0;
        let msg_type = 4;
        let cbsigma_msg_number = -1;
        let max_glrt = 0;
        let cbsigma_detecting = true;
        let offset_lat = 0;
        let offset_lon = 0;
        setInterval(() => {
            msg_number++;
            cbsigma_msg_number++;

            let message = new messages.Encounter.Encounter();
            let cbsigma_message;
            if ((msg_number % 5 === 0)) {
                msg_id = this.generateRandomId();
                msg_start_time = new Date().getTime();
                max_glrt = 0;
                message.finalized = false;
                cbsigma_detecting = true;
                cbsigma_msg_number = 0;
                msg_type++;

                offset_lat = Math.random() * 0.1;
                offset_lon = Math.random() * 0.1;
            } else if (msg_number % 5 === 4) {
                message.finalized = true;
                cbsigma_detecting = false;
            } else {
                message.finalized = false;
                cbsigma_detecting = true;
            }


            const center_lat = 40.753366 + offset_lat;
            const center_lon = -73.977698 + offset_lon;
            //CBSIGMA Message
            cbsigma_message = new messages.CBSigmaReport.CBSigmaOutput;
            cbsigma_message.agent_id = "Acetone";
            cbsigma_message.algorithm_state = 101;
            cbsigma_message.timestamp = new Date().getTime(); //in ms

            let points = [new messages.Rad.Location({latitude: center_lat+0.0001+0.0001*cbsigma_msg_number,longitude:center_lon+0.0001+0.0001*cbsigma_msg_number}),
                            new messages.Rad.Location({latitude: center_lat+0.0001+0.0001*cbsigma_msg_number,longitude:center_lon-0.0001-0.0001*cbsigma_msg_number}),
                            new messages.Rad.Location({latitude: center_lat-0.0001-0.0001*cbsigma_msg_number,longitude:center_lon-0.0001-0.0001*cbsigma_msg_number}),
                            new messages.Rad.Location({latitude: center_lat-0.0001-0.0001*cbsigma_msg_number,longitude:center_lon+0.0001+0.0001*cbsigma_msg_number})];
            let this_polygon = new messages.CBSigmaReport.Polygon({points:points})

            let this_contourLevel = new messages.CBSigmaReport.ContourLevel();
            this_contourLevel.timestamp = message.end_time
            this_contourLevel.concentration = 0.1
            this_contourLevel.contours = [new messages.CBSigmaReport.Contour({contour_outer:this_polygon})];
            cbsigma_message.contour_levels = [this_contourLevel];

            cbsigma_message.detection_significance = 45.0+cbsigma_msg_number*1.5;
            cbsigma_message.estimated_release_timestamp = msg_start_time/1000 - 10; //N.B. in seconds
            cbsigma_message.release_location = new messages.Rad.Location({
                            latitude: center_lat,//this.position[0],
                            longitude: center_lon// this.position[1]
                        });
            cbsigma_message.update_investigation = true;


            //CBSIGMA Encounter
            message.id = msg_id;
            message.start_time = msg_start_time;
            message.end_time = new Date().getTime() + 1000; //in ms
            message.user_generated = false;

            message.type = messages.Encounter.EncounterType.CHEMSIGMA;
            message.algorithm = this.generateRandomId();
            message.algorithm_name = "PSI CBSIGMA"
            message.current_glrt = cbsigma_message.detection_significance;
            message.max_glrt = message.current_glrt > max_glrt ? message.current_glrt : max_glrt;
            message.estimated_release_time = cbsigma_message.estimated_release_timestamp;
            message.estimated_release_location = new messages.Rad.Location({
                latitude: center_lat,//this.position[0],
                longitude: center_lon// this.position[1]
            });
            message.node_name = "PSI Tier2"
            message.source_location = message.estimated_release_location;
            message.chemicals = new messages.SigmaPlusChem.ChemicalIdentification;
            let this_target_id = new messages.SigmaPlusChem.ChemicalTargetIdentification();
                this_target_id.chemical = messages.SigmaPlusChem.SigmaPlusChemicalTarget.BY_CAS_REGISTRY_NUMBER
                this_target_id.cas_registry_number = "Acetone";
                this_target_id.concentration = 0.1;
            message.chemicals.identifications = [this_target_id];


            const header = new messages.Core.ExternalSensorMessageHeader({
                id: new messages.Core.UUID(),
                time: Date.now(),
                protocol_version: 'NA',
                device_name: 'PSI Tier2',
                topic: messages.Encounter.EncounterTopic
            });


            const data = this.packCopData(header, message);
            if (!data) return;
            this.callback(data);


            //Fake cbsigmaoutput
            if(cbsigma_detecting){
                const header2 = new messages.Core.ExternalSensorMessageHeader({
                    id: new messages.Core.UUID(),
                    time: Date.now(),
                    protocol_version: 'NA',
                    device_name: 'PSI Tier2',
                    topic: messages.CBSigmaReport.CBSigmaOutputTopic
                });
                const data2 = this.packCopData(header2, cbsigma_message);
                this.callback(data2);
            }

        }, 10000);
    }

    radEncounterMessageLoop() {

        let rad_msg_number = -1;
        let msg_id = this.generateRandomId();
        let msg_start_time = 0;
        let msg_type = 4;
        let cbsigma_msg_number = -1;
        let max_glrt = 0;
        let cbsigma_detecting = true;
        let offset_lat = 0;
        let offset_lon = 0;
        setInterval(() => {
            rad_msg_number++;

            let message = new messages.Encounter.Encounter();
            if ((rad_msg_number % 5 === 0)) {
                msg_id = this.generateRandomId();
                msg_start_time = new Date().getTime();
                max_glrt = 0;
                message.finalized = false;
                cbsigma_detecting = true;
                cbsigma_msg_number = 0;
                msg_type++;

                offset_lat = Math.random() * 0.1;
                offset_lon = Math.random() * 0.1;
            } else if (rad_msg_number % 5 === 4) {
                message.finalized = true;
                cbsigma_detecting = false;
            } else {
                message.finalized = false;
                cbsigma_detecting = true;
            }


            const center_lat = 40.753366 + offset_lat;
            const center_lon = -73.977698 + offset_lon;
            //CBSIGMA Message
            message.id = msg_id;
            message.start_time = msg_start_time;
            message.end_time = new Date().getTime() + 1000;
            message.user_generated = false;
            message.estimated_release_location = new messages.Rad.Location({
                latitude: center_lat,//this.position[0],
                longitude: center_lon// this.position[1]
            });
            message.node_name = "OWL-0042"
            message.source_location = message.estimated_release_location;
            message.vehicle_location = message.estimated_release_location;
            //if(msg_type % 2 === 1){
            /*
                if(rad_msg_number %2 === 1){
                    rad_src_dir= (rad_src_dir+1)%2;
                }
                let rad_srs_dir_rel_dir = rad_src_dir;
                if (rad_src_dir === 1){
                    rad_srs_dir_rel_dir = 90;
                } else if (rad_src_dir === 0){
                    rad_srs_dir_rel_dir = 270;
                }
                */
                message.type = messages.Encounter.EncounterType.RAD;
                message.isotopes = [new messages.Rad.IsotopeResult({
                    alarm: true,
                    category: 'MEDICAL',
                    name: 'TC_99M',
                    pcs_alpha: 2000,
                    pcs_confidence: 25,
                    pcs_value: 50
                })];
                /*
                if(set_rad_direction){
                    //message.source_lane_position = 0; //rad_src_dir
                    //message.relative_bearing_to_source = rad_srs_dir_rel_dir;//90;
                }
                */
                message.max_count_rate = 3800;
                message.max_dose_rate = 20;


            const header = new messages.Core.ExternalSensorMessageHeader({
                id: new messages.Core.UUID(),
                time: Date.now(),
                protocol_version: 'NA',
                device_name: 'OWL-0042',
                topic: messages.Encounter.EncounterTopic
            });


            const data = this.packCopData(header, message);
            if (!data) return;
            this.callback(data);


        }, 2800);
    }


    packCopData(header:messages.Core.ExternalSensorMessageHeader, data:ThriftWritable){
        let datapacket_messages: DataPacket[] = [];
        if (header.topic === messages.Encounter.EncounterTopic) {
            let encounter_message = data as messages.Encounter.Encounter;

            const timestamp = parseInt(encounter_message.start_time.toString());
            //HACK FOR BD21
            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'PSI', statusString:''};
            let parsed_data
            if (parsed_data !== null)
                datapacket_messages.push([datapacket_header, encounter_message]);

        } else if (header.topic === messages.CBSigmaReport.CBSigmaOutputTopic){
            header.device_name = "PSI";
            let parsed_data = data as messages.CBSigmaReport.CBSigmaOutput;
            let cbsigma_message = BD21DataStream.parseCBSigmaMessage(header.time, parsed_data, header);
            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'PSI CBSIGMA',statusString:''};
            if (cbsigma_message !== null)
                datapacket_messages.push([datapacket_header, cbsigma_message]);

        }
        return datapacket_messages;

    }
    /*
    packData(topic: string, data: ThriftWritable) {
        let packed_data: Buffer | null = null;
        let transport = new thrift.TFramedTransport(undefined, function (msg, seqid) {
            if (!msg) return;

            // Remove 4-byte header from FramedTransport
            packed_data = msg.slice(4);
        });

        let protocol = new thrift.TBinaryProtocol(transport);
        data.write(protocol);
        transport.flush();

        let header_data: Buffer | null = null;
        let header_transport = new thrift.TFramedTransport(undefined, function (msg, seqid) {
            if (!msg) return;

            // Remove 4-byte header from FramedTransport
            header_data = msg.slice(4);
        });

        const header = new messages.Core.ExternalSensorMessageHeader({
            id: new messages.Core.UUID(),
            time: Date.now(),
            protocol_version: 'NA',
            device_name: 'SNTEMP',
            topic: topic
        });

        let header_protocol = new thrift.TBinaryProtocol(header_transport);
        header.write(header_protocol);
        header_transport.flush();

        if (packed_data === null || header_data === null)
            return null;

        let topicHeader = new Buffer(messages.Core.ExternalSensorMessageTopic, 'binary');
        return Buffer.concat([topicHeader, header_data, packed_data]);
    }

    investigationMessageLoop() {
        let msg_number = 0;
        let msg_id = this.generateRandomId();
        let msg_start_time = 0;

        setInterval(() => {
            msg_number++;

            let message = new messages.Rad.Investigation();
            if (!(msg_number % 2)) {
                msg_id = this.generateRandomId();
                msg_start_time = new Date().getTime();
                message.finalized = false;
            } else if (msg_number % 2 === 1) {
                message.finalized = true;
            }

            message.id = msg_id;
            message.start_time = msg_start_time;
            message.end_time = new Date().getTime() + 1000;
            message.user_generated = false;

            message.isotopes = [new messages.Rad.IsotopeResult({
                alarm: true,
                category: 'INDUSTRIAL',
                name: 'CS_137',
                pcs_alpha: 2000,
                pcs_confidence: 25,
                pcs_value: 50
            })];

            message.max_count_rate = 3800;
            message.max_dose_rate = 20;

            message.vehicle_location = new messages.Rad.Location({
                latitude: this.position[0],
                longitude: this.position[1]
            });

            const data = this.packData(messages.Rad.InvestigationTopic, message);
            if (!data) return;

            let event = new MessageEvent('investigation', { data: data.toString('binary') });
            this.callback(event);
        }, 30000);
    }

    gpsMessageLoop() {
        let msg_number = 0;
        const center_lat = 42.754193;
        const center_lon = -71.111716;

        setInterval(() => {
            msg_number++;
            let message = new messages.Core.GPSReading();
            message.id = this.generateRandomId();
            message.time = Date.now();

            this.position = [
                center_lat + (0.005) * Math.sin(msg_number / 50),
                center_lon + (0.005) * Math.cos(msg_number / 50)
            ];

            message.lat = this.position[0];
            message.lon = this.position[1];
            message.heading = -(msg_number / 50) * 180 / 3.1415;
            message.quality = 1; //1=2D, 2=3D

            const data = this.packData(messages.Core.GPSReadingTopic, message);
            if (!data) return;

            let event = new MessageEvent('gps', { data: data.toString('binary') });
            this.callback(event);
        }, 1000);

        setInterval(() => {
            let message = new messages.Rad.HealthMessage();
            message.id = this.generateRandomId();
            message.time = Date.now();

            message.component = messages.Rad.HealthComponent.GPS;
            message.healthState = messages.Rad.HealthState.DEGRADED;
            message.ui_message = 'Fake Health';

            const data = this.packData(messages.Rad.HealthTopic, message);
            if (!data) return;

            let event = new MessageEvent('health', { data: data.toString('binary') });
            this.callback(event);
        }, 10000);
    }

    radHealthMessageLoop(){
        setInterval(() => {
            let message = new messages.Rad.HealthMessage();
            message.id = this.generateRandomId();
            message.time = Date.now();

            message.component = messages.Rad.HealthComponent.RAD;
            message.healthState = messages.Rad.HealthState.GOOD;
            message.ui_message = 'Fake Health';

            const data = this.packData(messages.Rad.HealthTopic, message);
            if (!data) return;

            let event = new MessageEvent('health', { data: data.toString('binary') });
            this.callback(event);
        }, 10000);
    }
    pcsHealthMessageLoop(){
        setInterval(() => {
            let message = new messages.Rad.HealthMessage();
            message.id = this.generateRandomId();
            message.time = Date.now();

            message.component = messages.Rad.HealthComponent.PCS;
            message.healthState = messages.Rad.HealthState.GOOD;
            message.ui_message = 'Fake Health';

            const data = this.packData(messages.Rad.HealthTopic, message);
            if (!data) return;

            let event = new MessageEvent('health', { data: data.toString('binary') });
            this.callback(event);
        }, 10000);
    }

    radMessageLoop() {
        setInterval(() => {
            let message = new messages.Rad.RadiationReading();
            message.id = this.generateRandomId();
            message.time = Date.now();

            let detector = new messages.Rad.DetectorReading();
            detector.livetime = 1;
            detector.spectrum = new Array(1024).fill(1.0);
            message.detectors.push(detector)

            const data = this.packData(messages.Rad.RadiationReadingRebinnedTopic, message);
            if (!data) return;

            let event = new MessageEvent('spectrum', { data: data.toString('binary') });
            this.callback(event);
        }, 1000);
    }

    neutronMessageLoop() {
        var iter = 0;
        setInterval(() => {
            let message = new messages.Rad.NeutronReading();
            message.id = this.generateRandomId();
            message.time = Date.now();
            message.detectors = [];

            let detector = new messages.Rad.NeutronDetectorReading();
            detector.livetime = 1;
            detector.count = iter % 3;
            message.detectors.push(detector)

            const data = this.packData(messages.Rad.NeutronReadingTopic, message);
            if (!data) return;

            let event = new MessageEvent('neutron', { data: data.toString('binary') });
            this.callback(event);

            iter++;
        }, 1000);

        setInterval(() => {
            let message = new messages.Rad.HealthMessage();
            message.id = this.generateRandomId();
            message.time = Date.now();

            message.component = messages.Rad.HealthComponent.NEUTRON;
            message.healthState = messages.Rad.HealthState.GOOD;
            message.ui_message = 'Fake Health';

            const data = this.packData(messages.Rad.HealthTopic, message);
            if (!data) return;

            let event = new MessageEvent('health', { data: data.toString('binary') });
            this.callback(event);
        }, 10000);

    }
    */

}

export class FakeImageData {

    static async loadDoseMapFile(){
        let n = new npyjs();
        const npyArray = await n.load(rawDoseMapFile)
        return npyArray
    }
    static async loadDoseStdMapFile(){
        let n = new npyjs();
        const npyArray = await n.load(rawDoseStdMapFile)
        return npyArray
    }
    static async loadNPZFile(){
      const response = await fetch(rawNPZFile);
      const blob = await response.blob();
      const zipData = await blob.arrayBuffer();
      const zip = await jszip.loadAsync(zipData);

      const npzData: {[key: string]: any} = {};

      for (const filename in zip.files) {
        if (filename.endsWith('.npy')) {
          const file = zip.files[filename];
          const arrayBuffer = await file.async('arraybuffer');
          const npy = new npyjs();
          const { data, shape, dtype } = await npy.load(arrayBuffer);
          npzData[filename.replace('.npy', '')] = { data, shape, dtype };
        }
      }

      return {npzData:npzData, blob:blob};
    }

    /*
    static async MakeDoseImage() {

            let n = new npyjs();
            const npyArray = await n.load(rawDoseMapFile)
            const npyStdArray = await n.load(rawDoseStdMapFile)

            const starttime = Date.now();
            console.log('npyArray loaded')
            let width = npyArray.shape[0];
            let height = npyArray.shape[1];
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')

            let minVal = 0.5;
            let maxVal  = 2.5;
            let numSteps = 255;

            let imgData = context!.createImageData(width, height);
            canvas.height = height;
            canvas.width = width;
            const data_in = npyArray.data as Float64Array;
            let normalized = FakeImageData.normalize(data_in,minVal,maxVal,255);

            const std_data_in = npyStdArray.data as Float64Array;
            let normalized_std = FakeImageData.normalize(std_data_in,0.4,0.5);

            let colors = colormap({
                colormap: 'jet',
                nshades: 256,
                format: 'rgba',
                alpha: 1
            })
            // fill imgData with colors from array
            for(let i = 0; i < normalized.length; i++) {
                // Convert pixels[i] to RGB
                // See http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
                const rgba = colors[normalized[i]]
                //if(1-normalized_std[i]>0){
                    imgData.data[4*i] = rgba[0];
                    imgData.data[4*i + 1] = rgba[1];
                    imgData.data[4*i + 2] = rgba[2];
                    imgData.data[4*i + 3] = (1-normalized_std[i])*255; // Alpha channel

            }
            // put data to context at (0, 0)
            context!.putImageData(imgData, 0, 0);
            // output image
            let img = new Image();
            img.src = canvas.toDataURL('image/png');

            let url = img.src;
            url = url.replace('data:image/png;base64,','');

            const endtime = Date.now();
            const elapsed = endtime - starttime;
            console.log('Elapsed Time (ms): '+elapsed)
            return url;
    }
    */

    static MakeDoseImage(npyArray:any,npyStdArray:any) {

            const starttime = Date.now();
            console.log('npyArray loaded')
            let width = npyArray.shape[0];
            let height = npyArray.shape[1];
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')

            let minVal = 0.5;
            let maxVal  = 2.5;
            let numSteps = 255;

            let imgData = context!.createImageData(width, height);
            canvas.height = height;
            canvas.width = width;
            const data_in = npyArray.data as Float64Array;
            let normalized = FakeImageData.normalize(data_in,minVal,maxVal,255);

            const std_data_in = npyStdArray.data as Float64Array;
            let normalized_std = FakeImageData.normalize(std_data_in,0.4,0.5);

            let colors = colormap({
                colormap: 'jet',
                nshades: 256,
                format: 'rgba',
                alpha: 1
            })
            // fill imgData with colors from array
            for(let i = 0; i < normalized.length; i++) {
                // Convert pixels[i] to RGB
                // See http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
                const rgba = colors[normalized[i]]
                //if(1-normalized_std[i]>0){
                    imgData.data[4*i] = rgba[0];
                    imgData.data[4*i + 1] = rgba[1];
                    imgData.data[4*i + 2] = rgba[2];
                    imgData.data[4*i + 3] = (1-normalized_std[i])*255; // Alpha channel

            }
            // put data to context at (0, 0)
            context!.putImageData(imgData, 0, 0);
            // output image
            let img = new Image();
            img.src = canvas.toDataURL('image/png');

            let url = img.src;
            url = url.replace('data:image/png;base64,','');

            const endtime = Date.now();
            const elapsed = endtime - starttime;
            console.log('Elapsed Time (ms): '+elapsed)
            return url;
    }


    static normalize(data_in:Float64Array, min_val:number, max_val:number, scale_in?:number){
        const scale = scale_in?scale_in:1;
        let inv_step = 1/(max_val - min_val);
        let data_out = new Uint8Array(data_in.length);
        for(let i = 0; i < data_in.length; i++) {
            if(data_in[i] > max_val){
                data_out[i] = scale;
            } else if (data_in[i] < min_val){
                data_out[i] = 0;
            } else {
                //data_out[i] = (data_in[i] - min_val)/(max_val-min_val)*256;
                data_out[i] = (data_in[i] - min_val)*inv_step*scale;
            }
            //console.log('i: '+i+' '+data_in[i]+i+' '+data_out[i])
        }
        return data_out;
    }
}

/*
def colormap(data, min_dose, max_dose, min_dose_std, max_dose_std):
buffer = io.BytesIO(data)
data = np.load(buffer)
dose = data['dose']
dose_std = data['dose_std']

colors_array = ["b", "c", "g", "y", "r"]
cm = LinearSegmentedColormap.from_list("custom", colors_array)
norm = Normalize(min_dose, max_dose, clip=True)
std_norm = Normalize(min_dose_std, max_dose_std, clip=True)
mask_norm = Normalize(0.4, 0.5, clip=True)

mask = 1.0 - mask_norm(dose_std)

dose = cm(norm(dose))
dose[:, :, 3] = mask

dose_std = cm(std_norm(dose_std))
dose_std[:, :, 3] = mask

dose = Image.fromarray((dose * 255).astype(np.uint8))
dose_buffer = io.BytesIO()
dose.save(dose_buffer, "PNG")
dose_buffer.seek(0)

dose_std = Image.fromarray((dose_std * 255).astype(np.uint8))
dose_std_buffer = io.BytesIO()
dose_std.save(dose_std_buffer, "PNG")
dose_std_buffer.seek(0)

return dose_buffer.getvalue(), dose_std_buffer.getvalue()
*/
